import { useEffect, useRef } from 'react';

const services = [
  {
    icon: 'ri-truck-line',
    color: 'bg-orange-500',
    title: 'Parsiyel Taşımacılık',
    desc: 'Küçük ve orta ölçekli yüklerinizi diğer kargolarla birleştirerek ekonomik ve hızlı şekilde yurtiçi ve yurtdışı hedeflere ulaştırıyoruz.',
  },
  {
    icon: 'ri-box-3-line',
    color: 'bg-slate-800',
    title: 'Komple Araç',
    desc: 'Büyük hacimli yükleriniz için komple araç kiralama hizmeti sunuyor, yükünüzü doğrudan hedef noktaya teslim ediyoruz.',
  },
  {
    icon: 'ri-flashlight-line',
    color: 'bg-amber-500',
    title: 'Ekspres Teslimat',
    desc: 'Acil yükleriniz için öncelikli ekspres taşımacılık hizmeti ile en kısa sürede teslimat garantisi veriyoruz.',
  },
  {
    icon: 'ri-file-list-3-line',
    color: 'bg-emerald-600',
    title: 'Gümrük İşlemleri',
    desc: 'Deneyimli ekibimizle tüm gümrük prosedürlerini sizin adınıza yönetiyor, bürokratik süreçleri kolaylaştırıyoruz.',
  },
];

export default function Services() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-10');
          }
        });
      },
      { threshold: 0.1 }
    );
    const children = sectionRef.current?.querySelectorAll('.animate-on-scroll');
    children?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="hizmetler" className="py-24" style={{ background: '#f8f6f3' }} ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 animate-on-scroll opacity-0 translate-y-10 transition-all duration-700">
          <div>
            <span className="text-orange-500 text-sm font-bold uppercase tracking-widest mb-3 block">
              Hizmetlerimiz
            </span>
            <h2
              className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Sunduğumuz<br />
              <span className="text-orange-500">Lojistik Çözümler</span>
            </h2>
          </div>
          <p className="text-gray-500 max-w-sm mt-4 md:mt-0 text-sm leading-relaxed">
            Müşterilerimizin ihtiyaçlarına özel, esnek ve güvenilir taşımacılık çözümleri sunuyoruz.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <div
              key={s.title}
              className="animate-on-scroll opacity-0 translate-y-10 transition-all duration-700 group bg-white rounded-2xl overflow-hidden hover:-translate-y-2 hover:shadow-lg cursor-pointer"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              {/* Icon Area */}
              <div className={`${s.color} h-36 flex items-center justify-center`}>
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 rounded-2xl">
                  <i className={`${s.icon} text-white text-3xl`} />
                </div>
              </div>
              {/* Content */}
              <div className="p-6">
                <h3 className="text-gray-900 font-bold text-lg mb-3">{s.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{s.desc}</p>
                <div className="mt-5 flex items-center gap-2 text-orange-500 font-semibold text-sm group-hover:gap-3 transition-all">
                  <a href="/iletisim" className="flex items-center gap-2 cursor-pointer">
                    iletişime geç <i className="ri-arrow-right-line" />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
